import React, { useState, useEffect } from "react";
import { Button, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useWarehousingModel } from "./WarehousingModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";


export const DataBox = () => {
    const { selectedRowKeys, setWsConfirmModal } = useWarehousingModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const [visible, setVisible] = useState(false);
    const onWsConfirm = () => {
        if (selectedRowKeys.length !== 1) {
            return message.error("请选择一条数据")
        }
        setWsConfirmModal(true)
    }
    const action = <>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => onWsConfirm()}
        >入库</Button>
    </>;

    return (
        <>
            <YhBox title={action} >
                <DataTable />
            </YhBox>
        </>
    )
}